import AppLogo from "./Logo";
import { Spinner } from "./ui/spinner";

import { cn } from "@/lib/utils.ts";

interface props {
  className?: string;
}

const AppLoader = ({ className }: props) => {
  return (
    <div
      className={cn(
        "fixed top-0 left-0 flex h-dvh w-screen flex-col items-center justify-center gap-10",
        className,
      )}
    >
      <AppLogo className="w-56" />
      <Spinner className="bg-accent-foreground" size="xl" />
    </div>
  );
};

export default AppLoader;
